import { Link } from 'react-router-dom';
import { Lock, CheckCircle } from 'lucide-react';
import ProgressBar from './ProgressBar';

const topicIcons = {
  '01_basics': '📝',
  '02_types': '🔤',
  '03_lists': '📋',
  '04_records': '📦',
  '05_tables': '📊',
  '06_functions': '⚙️',
  '07_advanced': '🚀',
  '08_formats': '📄',
  '09_challenge': '🏆',
};

export default function TopicCard({
  topic,
  completion = 0,
  totalChallenges,
  completedChallenges,
  isLocked = false,
}) {
  const isComplete = completion === 100;
  const icon = topicIcons[topic.id] || '📁';

  const content = (
    <div
      className={`
        h-full flex flex-col relative overflow-hidden rounded-2xl border transition-all duration-300 card-hover
        ${isLocked
          ? 'opacity-50 cursor-not-allowed border-[#2a2d31] bg-game-surface'
          : 'border-[#2a2d31] hover:border-game-primary bg-game-surface'
        }
      `}
    >
      {/* Header - Teal gradient */}
      <div className="h-28 flex-shrink-0 bg-gradient-to-br from-game-primary to-game-teal-dark flex items-center justify-center relative">
        <span className="text-5xl">{icon}</span>
        {isComplete && (
          <div className="absolute top-3 right-3 bg-game-accent rounded-full p-1">
            <CheckCircle className="text-game-bg" size={18} />
          </div>
        )}
        {isLocked && (
          <div className="absolute top-3 right-3 bg-game-secondary rounded-full p-2">
            <Lock className="text-game-text-dim" size={18} />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-grow">
        <h3 className="font-bold text-lg text-game-text mb-2">
          {topic.name}
        </h3>
        <p className="text-sm text-game-text-dim mb-4 line-clamp-2 flex-grow">
          {topic.description}
        </p>

        {/* Progress - always at bottom */}
        <div className="mt-auto">
          <div className="flex items-center justify-between text-xs text-game-text-dim mb-2">
            <span>{completedChallenges} / {totalChallenges} challenges</span>
            <span className={isComplete ? 'text-game-accent font-semibold' : 'text-game-accent font-semibold'}>
              {completion}%
            </span>
          </div>
          <ProgressBar
            value={completion}
            max={100}
            showLabel={false}
            height="h-2"
            color="bg-game-primary"
          />
        </div>
      </div>
    </div>
  );

  if (isLocked) {
    return content;
  }

  return (
    <Link to={`/topic/${topic.id}`} className="h-full block">
      {content}
    </Link>
  );
}
